import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { RADIO_BUTTONS_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggRadioSelectToLegacyField: FieldTransformer<
	typeof RADIO_BUTTONS_CF_TYPE
> = (node) => {
	if (node.type !== RADIO_BUTTONS_CF_TYPE) return undefined;

	const value = node.selectedOption
		? {
				id: node.selectedOption?.optionId,
				value: node.selectedOption?.value,
				isDisabled: node.selectedOption?.isDisabled,
			}
		: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			type: 'option',
			renderer: PLAIN_TEXT,
			custom: node.type,
			system: null,
			items: null,
			configuration: null,
		},
	};
};
